export interface Blinkable {
    visible: boolean
}

export class Blinker {

    turnOff: () => void
    private readonly intervalId: number
    private on = true

    constructor(blinkable: Blinkable, timeout = 500) {
        this.intervalId = window.setInterval(() => {
            this.on = !this.on
            blinkable.visible = this.on
        }, timeout)
        this.turnOff = () => {
            blinkable.visible = false
            this.stop()
        }
    }

    stop = () => {
        window.clearInterval(this.intervalId)
        this.on = false
    }
}
